import styled from "@emotion/styled/macro";
import {PropsWithChildren, useState} from "react";
import LogInSearch from "../screens/logIn/LogInSearch";
import AccountFound from "../screens/logIn/AccountFound";
import CreateAccount from "../screens/logIn/CreateAccount";
import Button from "../common/button/Button";



const RegistrationOverlayDiv = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  width:550px;
  height:514px;
  padding: 50px;
  display:flex;
  flex-direction:column;

`

type RegistrationStep = "find" | "found" | "create";

const RegistrationFind: React.FC = (props) => {
    return <section>
        <h3>On2 Homes Registration</h3>
        <p>Enter phone number to get started</p>
        <input type={"tel"}></input>
    </section>
}


export const RegistrationOverlay: React.FC<{onComplete: () => void, onCancel: () => void}> = (props) => {
    const { onComplete, onCancel } = props;
    const [step, setStep] = useState<RegistrationStep>("find");
    const [phone, setPhone] = useState<string>("");
    const nothing = () => {};

    return <RegistrationOverlayDiv>
        { step === "find" && <section>
            <h3>On2 Homes Registration</h3>
            <p>Enter phone number to get started</p>
            <LogInSearch onSkipLogin={onCancel} skipText={"cancel"} onCreateAccount={(phone:string) =>{
                setPhone(phone);
                setStep("create");}
                } onAccountFound={() => setStep("found")} />
        </section>
            }
        { step === "found" && <section>
            <h3>Account Found</h3>
            <p>Please check that your information is correct</p>
            <AccountFound onCompleteLogin={onComplete} />
        </section>}
        { step === "create" &&
        <section>
            <h3>Create An Account</h3>
            <p>Please enter your information below to reserve</p>
            <CreateAccount searchedPhone={phone} onCompleteLogin={onComplete} onCancel={onCancel} />
        </section>}

    </RegistrationOverlayDiv>


}


const PurchaseOverlayDiv = styled.div`

  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  width:500px;
  height:514px;
  padding: 50px;
  display:flex;
  flex-direction:column;
  .close {
    align-self: end;
  }
  .content {
    align-self: center;
  }
  
`
const PurchaseOverlay: React.FC<PropsWithChildren<{onClose: () => void, onConfirm: () => void}>> = props => {

    const { onClose, onConfirm } = props;
    return <PurchaseOverlayDiv>
        <div className={"close"} onClick={onClose}>X</div>
        <div className={"content"}>
            { props.children }
            <Button primary onClick={onConfirm} text={"Confirm"}></Button>
        </div>
    </PurchaseOverlayDiv>
}

export default PurchaseOverlay;